import { Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function ScheduleOrientationTitle() {
  return (
    <Stack spacing={4}>
      <Title variant="h3" component="h2">
        Schedule your Demo Shift
      </Title>

      <Text light variant="body1">
        Pick a time to watch a quick virtual walkthrough of your first shift.
      </Text>
    </Stack>
  );
}
